<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>HISTORICO DE CORREOS</strong></h5>
            </vs-col>
            <vs-col w="12" v-for="(user, i) in correos" :key="i" class="pb-2 pt-3 divisorWithLine">
                <div class="estatus-alumno mb-2" :class="user.correo_vinculado_a_usuario == true ? 'col-blue' : 'col-yellow'" v-if="general.datos">
                    <small><strong>{{user.correo_vinculado_a_usuario == true ? 'Correo vinculado' : 'Correo no vinculado'}}</strong></small>
                </div>
                <h6>{{user.institucion}}</h6>
                <vs-row style="align-items: center;">
                    <vs-col sm="12" lg="5">
                        <label>Correo electrónico*</label>
                        <vs-input
                            class="pt-0 pl-0"
                            v-model="user.correo_institucional"
                            placeholder="Nombre"
                        />
                    </vs-col>
                    <vs-col sm="12" lg="2" class="d-flex">
                        <vs-button
                            flat
                            @click="getEditarCorreoHistorico(user, user.correo_institucional)"
                                md-menu-trigger
                        >
                            <i class="fas fa-edit mr-2"></i> Editar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
    ],
    data(){
        return{
            correos: []
        }
    },
    methods: {
        async getHistoricoCorreo(){
            const params = {
                persona_id: this.general.datos.persona_id
            }
            const {data: response} = await alumnos.getHistoricoCorreo(params)
            this.correos = response
            // this.correos = [
            //     {
            //         correo_institucional_id: 1,
            //         persona_id: 12,
            //         institucion_id: 1,
            //         institucion: 'INSTITUTO MEXICO PRIMARIA (AMORES CDMX)',
            //         correo_institucional: 'prueba@pruebita.com',
            //         correo_vinculado_a_usuario: true
            //     },
            //     {
            //         correo_institucional_id: 1,
            //         persona_id: 12,
            //         institucion_id: 1,
            //         institucion: 'INSTITUTO MEXICO SECUNDARIA (POPO)',
            //         correo_institucional: 'prueba@correo.com',
            //         correo_vinculado_a_usuario: false
            //     }
            // ]
        },
        async getEditarCorreoHistorico(user, correo){
            const loading = this.$vs.loading()
            try{
                const params = {
                    persona_id: user.persona_id,
                    institucion_id: user.institucion_id,
                    correo: correo
                }
                const {data: response} = await alumnos.getEditarCorreoHistorico(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: 'Se actualizó correctamente el correo'
                })
                loading.close()
                this.getHistoricoCorreo()
            }catch(error){
                console.error(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal',
                    text: 'Favor de poner en contacto con el administrador'
                })
                loading.close()
            }
            
        }
    },
    watch:{
        general(){
            this.getHistoricoCorreo()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
.hiperlink{
    color: rgb(50, 132, 240);
    font-weight: bold;
    cursor: pointer;
}
</style>

<style lang="scss" scoped>

    .estatus-alumno{
        display:inline-block;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
</style>
